<div class="entity-card" [routerLink]="['/', entityType.toLowerCase() + 's', entity?.id]">
    <div class="entity-card-content">
        <div class="flex flex-row justify-content-between align-items-center w-full mb-3">
            <div>
                <img ngSrc="assets/svg/{{entity?.classIcon}}.svg" width="48" height="48" alt="class icon">
            </div>

            <div class="flex flex-row gap-3 align-items-center h-full mr-3">
                <!--OFFLINE device-->
                @if (isEntityOffline(entity?.id)) {
                    <div class="flex align-items-center cursor-auto">
                        <mat-icon class="header-icon cbms-red-color" svgIcon="wifi_off"
                            pTooltip="This determines the data points are missing and / or flatlining. Please check in detailed view and history graph.">
                        </mat-icon>
                    </div>
                }

                <!--ALERTS count-->
                <div class="flex align-items-center alert-badge cursor-auto"
                    [ngClass]="getAlertBadgeClass(filteredSmartAlerts)">
                    <i class="pi pi-bell"
                        pTooltip="This determines the priority and number of active smart alerts. Please check in detailed view, under Smart Alerts sub section."></i>
                    @if (filteredSmartAlerts?.length > 0) {
                        <strong>
                            &nbsp; {{ filteredSmartAlerts?.length }}
                        </strong>
                    }
                </div>
                <!--overridden point - lock button/icon -->
                @if (isEntityOverridden(entity?.id)) {
                    <div>
                        <i class="pi pi-lock is-overridden cursor-auto" pTooltip="This determines the overridden points. Please check in detail view."></i>
                    </div>
                }
                <div>
                    @if (entity?.pinned) {
                        <eon-ui-icon class="cursor-pointer"
                                     name="bookmark"
                                     (click)="togglePin($event, entity)"></eon-ui-icon>
                    } @else {
                        <eon-ui-icon class="cursor-pointer"
                                     name="bookmark_outline"
                                     (click)="togglePin($event, entity)"></eon-ui-icon>
                    }
                </div>
            </div>
        </div>

        <div class="entity-details">
            <h2
                class="entity-name"
                [pTooltip]="entity?.label"
                [tooltipDisabled]="
                                    entity?.label &&
                                    entity?.label?.length <= 30
                                "
                tooltipPosition="top"
                [hideDelay]="100"
            >
                {{ entity?.label }}
            </h2>
            <p class="entity-class">{{ entity?.classLabel }}</p>
        </div>
    </div>
    <div class="entity-card-footer">
        @if (entity?.selectedKpi?.signalType) {
            <div class="entity-kpi flex align-items-center justify-content-around">
                @switch (entity?.selectedKpi?.signalType) {
                    @case ('Binary') {
                        <span class="margin-right-05 width-80-percent">{{
                            entity?.selectedKpi?.comment || entity?.selectedKpi?.classLabel
                        }}</span>
                        <p-toggleswitch class="default-switch__black" [disabled]="true"
                                       [(ngModel)]="entity.selectedKpi.presentValue"></p-toggleswitch>
                    }
                    @default {
                        <span class="margin-right-05 width-80-percent">{{
                            entity?.selectedKpi?.comment || entity?.selectedKpi?.classLabel
                        }}</span>
                        <span class="kpi-value">
                            {{ entity?.selectedKpi?.presentValue }}
                            <span style="font-size:1rem"
                                [innerHTML]="entity?.selectedKpi?.htmlSymbol"></span>
                        </span>
                    }
                }
            </div>
        }
    </div>
</div>
